











import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { API } from '../../services/config/config.service';

let CKEDITOR;

@Component({})
export default class HtmlInputComponent extends Vue {
    @Prop({ default: 'editor' })
    public id: string;

    @Prop() public value: string;

    public beforeUpdate() {
        const ckeditorId = this.id;
        if (this.value !== CKEDITOR.instances[ckeditorId].getData()) {
            CKEDITOR.instances[ckeditorId].setData(this.value);
        }
    }

    public destroyed() {
        const ckeditorId = this.id;
        if (CKEDITOR.instances[ckeditorId]) {
            CKEDITOR.instances[ckeditorId].destroy();
        }
    }

    public mounted() {
        CKEDITOR = window['CKEDITOR'];
        const imagePluginName = 'simage';

        const extraPlugins = [
            'simage',
            'smiley',
            'panelbutton',
            'clipboard',
            'colorbutton',
            'colordialog',
            'pastefromword',
            'justify',
            'font',
            'newpage',
            'preview',
            'templates',
            'pastetext',
            'find',
            'selectall',
            'basicstyles',
            'div',
            'flash',
            'pagebreak'
        ];

        extraPlugins.forEach((x) => this.addPlugin(x));

        const colorsList = [
            '000',
            '800000',
            '8B4513',
            '2F4F4F',
            '008080',
            '000080',
            '4B0082',
            '696969',
            'B22222',
            'A52A2A',
            'DAA520',
            '006400',
            '40E0D0',
            '0000CD',
            '800080',
            '808080',
            'F00',
            'FF8C00',
            'FFD700',
            '008000',
            '0FF',
            '00F',
            'EE82EE',
            'A9A9A9',
            'FFA07A',
            'FFA500',
            'FFFF00',
            '00FF00',
            'AFEEEE',
            'ADD8E6',
            'DDA0DD',
            'D3D3D3',
            'FFF0F5',
            'FAEBD7',
            'FFFFE0',
            'F0FFF0',
            'F0FFFF',
            'F0F8FF',
            'E6E6FA',
            'FFF'
        ];

        const ckeditorId = this.id;

        const ckeditorConfig = {
            extraPlugins: extraPlugins.join(','),
            removePlugins: 'magicline',
            skin: 'kama,/vendors/skins/kama/',
            height: 500,
            filebrowserUploadUrl: API + 'files/image',
            imageUploadURL: API + 'files/image',
            removeButtons: '',
            colorButton_colors: colorsList.join(','),
            colorButton_colorsPerRow: 8,
            colorButton_enableMore: true,
            toolbar: [
                ['Source'],
                ['NewPage', 'Preview'],
                ['Templates'],
                // { name: 'document', items: [ 'Source', '-', 'NewPage', 'Preview', '-', 'Templates' ] },

                ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord'],
                ['Undo', 'Redo'],
                ['Find', 'Replace'],
                ['SelectAll', 'RemoveFormat'],
                '/',
                ['Bold', 'Italic', 'Underline', 'Strike'],
                ['Subscript', 'Superscript'],
                ['NumberedList', 'BulletedList'],
                ['Outdent', 'Indent', 'Blockquote', 'CreateDiv'],
                [
                    'JustifyLeft',
                    'JustifyCenter',
                    'JustifyRight',
                    'JustifyBlock'
                ],
                ['Link', 'Unlink', 'Anchor'],
                [
                    'Image',
                    'Flash',
                    'Table',
                    'HorizontalRule',
                    'Smiley',
                    'SpecialChar',
                    'PageBreak'
                ],
                '/',
                ['Styles', 'Format', 'Font', 'FontSize'],
                ['TextColor', 'BGColor']
            ],
            extraAllowedContent: 'marquee[behavior, direction]',

            // toolbarGroups: [
            //     { name: 'document', groups: ['mode', 'document', 'doctools'] },
            //     { name: 'clipboard', groups: ['clipboard', 'undo'] },
            //     {
            //         name: 'editing',
            //         groups: ['find', 'selection', 'spellchecker', 'editing']
            //     },
            //     { name: 'forms', groups: ['forms'] },
            //     '/',
            //     { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
            //     {
            //         name: 'paragraph',
            //         groups: [
            //             'list',
            //             'indent',
            //             'blocks',
            //             'align',
            //             'bidi',
            //             'paragraph'
            //         ]
            //     },
            //     { name: 'links', groups: ['links'] },
            //     { name: 'insert', groups: ['insert', `${imagePluginName}`] },
            //     '/',
            //     { name: 'styles', groups: ['styles'] },
            //     { name: 'colors', groups: ['colors'] },
            //     { name: 'tools', groups: ['tools'] },
            //     { name: 'others', groups: ['others'] },
            //     { name: 'about', groups: ['about'] }
            // ]
        };

        CKEDITOR.replace(ckeditorId, ckeditorConfig);
        CKEDITOR.instances[ckeditorId].setData(this.value);
        CKEDITOR.instances[ckeditorId].on('change', () => {
            let ckeditorData = CKEDITOR.instances[ckeditorId].getData();
            if (ckeditorData !== this.value) {
                this.$emit('input', ckeditorData);
            }
        });
    }

    private addPlugin(pluginName: string) {
        CKEDITOR.plugins.addExternal(
            pluginName,
            `/vendors/${pluginName}/`,
            'plugin.js'
        );
    }
}
